import { Component, OnInit } from '@angular/core';
import { ApiService } from '../shared/services/api.service';
import { PageEvent } from '@angular/material/paginator';
import { HttpClient } from '@angular/common/http';

import { FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';

import { CommonService } from '../shared/services/common.service';
import { ExportService } from '../shared/services/exportservice';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatLabel } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatTableModule } from '@angular/material/table';
import { MatModule } from '../appModules/mat.module';

@Component({
  selector: 'app-processed-result-stats',
  imports: [
    MatCardModule,
    MatTableModule,
    MatButtonModule,
    MatMenuModule,
    CommonModule,
    MatLabel,
    MatSelectModule,
    FormsModule,
    MatPaginatorModule,
    MatModule,
    ReactiveFormsModule
  ],
  templateUrl: './processed-results-stats.component.html',
  styleUrl: './processed-results-stats.component.scss'

})
export class ProcessedResultsStatsComponent implements OnInit {
  processedStats: any[] = [];
 displayedStatsColumns: string[] = [
  'sl_no',
  'register_no',
  ...[1, 2, 3, 4, 5, 6].flatMap(sem => [
    `sem${sem}_credits_earned`,
    `sem${sem}_weighted_average`,
    `sem${sem}_SGPA`,
    `sem${sem}_attempt_count`
  ]),
  'cumulative_credits_earned',
  'cgpa',
  'cumulative_percentage',
  'cumulative_result',
  'exam_month',
  'exam_year'
];




  statsSearched = false;

  courseList: any[] = [];
  semesterList: any[] = [];
  months = [];
  years = Array.from({ length: 10 }, (_, i) => ({ year_name: new Date().getFullYear() - i }));

  selectedCourseId: string = '';
  exam_month: string = '';
  exam_year: string = '';
  searchText: string = '';

  pagination = {
    page: 1,
    limit: 10,
    length: 0
  };

  isLoading = false;

  constructor(private api: ApiService, private exportService: ExportService) { }

  ngOnInit(): void {
    this.loadCourses();
    this.year_list();
    this.month_list();
  }


  year_list() {
    this.api.get('settings/year_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.years = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }

  month_list() {
    this.api.get('settings/month_list').subscribe({
      next: (resp) => {
        if (resp.success) {
          this.months = resp.data
          console.log('Year list fetched', resp.data);
        }
      },
      error: (err) => {
        console.error('Error fetching year list:', err);
      }
    });
  }


  loadCourses() {
    this.api.get('courses/list').subscribe((res: any) => {
      this.courseList = res?.data || [];
    });
  }


  onFiltersChange() {
    this.statsSearched = true;
    this.pagination.page = 1;
    this.fetchProcessedStats();
  }

  fetchProcessedStats_download() {
    this.isLoading = true;
    const queryParams = [
      `course_id=${this.selectedCourseId}`,
      `exam_month=${this.exam_month}`,
      `exam_year=${this.exam_year}`,
      // `page=${this.pagination.page}`,
      // `limit=${this.pagination.limit}`
    ];

    if (this.searchText) {
      queryParams.push(`search=${encodeURIComponent(this.searchText)}`);
    }

    const queryString = queryParams.join('&');
    const url = `results/processed/stats?${queryString}`;

    this.api.get(url).subscribe((res: any) => {
      this.processedStats = res?.data || [];
      this.pagination.length = res?.totalCount || 0;
      this.isLoading = false;
      const req = {
            displayedColumns: this.displayedStatsColumns,
            data: this.processedStats,
            filename: 'students_list',
            dateField: ['dob'] // or any date fields if needed
          };
          
          this.exportService.exportExcel(req);
    },
      (err) => {
        console.error('Error fetching stats:', err);
        this.isLoading = false;
      }
    );
  }

  fetchProcessedStats(search?: string) {
    this.isLoading = true;
    const queryParams = [
      `course_id=${this.selectedCourseId}`,
      `exam_month=${this.exam_month}`,
      `exam_year=${this.exam_year}`,
      `page=${this.pagination.page}`,
      `limit=${this.pagination.limit}`
    ];

    if (this.searchText) {
      queryParams.push(`search=${encodeURIComponent(this.searchText)}`);
    }

    const queryString = queryParams.join('&');
    const url = `results/processed/stats?${queryString}`;

    this.api.get(url).subscribe((res: any) => {
      this.processedStats = res?.data || [];
      this.pagination.length = res?.totalCount || 0;
      this.isLoading = false;
    },
      (err) => {
        console.error('Error fetching stats:', err);
        this.isLoading = false;
      }
    );
  }

  applyFilter() {
    this.pagination.page = 1;
    this.fetchProcessedStats(this.searchText);
  }

  pageEvent(event: PageEvent) {
    this.pagination.page = event.pageIndex + 1;
    this.pagination.limit = event.pageSize;
    this.fetchProcessedStats();
  }
}
